import Grid from "@mui/material/Grid2";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

export default function GridCheckbox({
  id = "",
  key = "",
  columnSize,
  label,
  value,
  required,
  disabled = false,
  onChange = null,
  checked = false,
}) {
  return (
    <Grid size={Number(columnSize)}>
      <FormControlLabel
        control={<Checkbox id={id} key={key} onChange={(e) => onChange(e)} />}
        required={required}
        disabled={disabled}
        label={label}
        value={value}
        checked={checked}
      />
    </Grid>
  );
}
